import {PlainDtoModel} from "../../../../common/entity/dto/plain/plainDto.model";
import {
        CommunicationConfigurationEmailModel
} from "../../../../communication/configuration/email/common/api/model/communicationConfigurationEmail.model";
import {LovValueSummary} from "../../../../common/lov/lov-value/api/model/lovValueSummary.model";

export class ReportDefinitionEmailConfigurationModel implements PlainDtoModel {
        emailConfiguration: CommunicationConfigurationEmailModel;
        type: LovValueSummary;
}
